// extracted by mini-css-extract-plugin
export default {"container":"jj-z","blurb":"kj-z","links":"lj-z"};